import { Modal } from 'antd';
import styled from 'styled-components';

// MENU MANAGE INDEX
export const SearchOptionButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  .search-option-title {
    font-size: 18px;
    font-weight: 600;
  }
  .search-option-buttons {
    display: flex;
    gap: 15px;
  }
  button {
    width: 150px;
    height: 40px;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 500;
  }
  .btn-success {
    background-color: #47ae66;
    border-color: #47ae66;
  }
  .btn-warning {
    background-color: #f0ad4e;
    border-color: #f0ad4e;
  }
  .btn-danger {
    background-color: #d9534f;
    border-color: #d9534f;
  }
`;

export const MenuSearchInputWrapper = styled.div`
  width: 350px;

  .ant-input-search {
    height: 40px;
  }

  .ant-input-search-button {
    height: 40px;
    border-radius: 0 5px 5px 0;
    font-size: 16px;
    font-weight: 500;
  }

  .ant-input-affix-wrapper {
    height: 40px;
    border-radius: 5px 0 0 5px;
    font-size: 16px;
  }

  .ant-input {
    height: 38px;
    font-size: 16px;
  }

  .ant-input::placeholder {
    font-size: 14px;
  }

  .ant-input-search .ant-input-group .ant-input-affix-wrapper:not(:last-child) .ant-input {
    height: 10px;
    padding: 13px 6px;
  }

  .ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
    height: 40px;
  }
`;

export const StickySearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 60px;
  left: 290px;
  right: 0;
  z-index: 100;
  padding: 20px;
  background-color: #f6f6f6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 1400px) {
    left: 0;
  }
`;

export const ContentWrapper = styled.div`
  min-height: calc(100vh - 150px);
  margin-top: 80px;

  .button-group {
    display: flex;
    justify-content: end;
    gap: 16px;
    margin: 0px 16px 16px;

    button {
      height: 40px;
      font-size: 14px;
      border-radius: 5px;
    }
  }
`;

export const CategoryWrapper = styled.div`
  .menu-list-wrapper {
    background: #ffffff;
    padding: 0px 16px;
  }

  .caregory-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 54px;
    padding: 0px 20px;
    background: #f8f8f8;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-size: 18px;
    font-weight: 700;

    .menu-count {
      padding-left: 4px;
      font-size: 14px;
      font-weight: 500;
      color: #666;
    }
  }

  .no-menu-registered {
    background: #ffffff;
    font-size: 16px;
    text-align: center;
    padding: 40px 20px;
    margin: 16px 0px;
    border-radius: 4px;
  }
`;

// MENU MANAGE MENU CARD
export const MenuCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .preview-image {
    overflow: hidden;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }

  .menu-plan-name {
    padding-top: 16px;
    padding-bottom: 5px;
    font-size: 18px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  input[type='file'] {
    display: none;
  }

  .menu-intro {
    font-size: 14px;
    color: #888888;
    margin-bottom: 16px;
    line-height: 1.5;
    min-height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

export const MenuThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: cente;
  width: 100%;
  height: 200px;
  background: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: auto;

  .non-image-description {
    width: 100%;
    text-align: center;

    .image-guide-description {
      font-size: 12px;
      color: #acacac;
    }
  }
`;

export const MenuStatusButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledDropdownButton = styled.div<{ $type: 'MENU' | 'ALL_MENU'; $backgroundColor: string; $borderColor: string }>`
  .ant-dropdown-button {
    width: ${(props) => (props.$type === 'MENU' ? '110px' : '170px')};
  }

  .ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled])::after {
    background-color: transparent !important;
  }

  .ant-btn-primary {
    background-color: ${(props) => props.$backgroundColor} !important;
    border-color: ${(props) => props.$borderColor} !important;

    &:hover,
    &:focus {
      background-color: ${(props) => props.$backgroundColor} !important;
      border-color: ${(props) => props.$borderColor} !important;
      opacity: 0.9;
    }
  }

  .ant-btn-compact-first-item {
    min-width: 80px;
  }

  .status-all-change-button {
    width: 170px;
  }

  [disabled] {
    opacity: 0.5;
    cursor: not-allowed;
    color: #ffffff;
  }
`;

export const MenuButtonGroup = styled.div`
  display: flex;
  gap: 8px;
  margin-top: auto;

  button {
    width: 100%;
    height: 34px;
    padding: 0;
    border-radius: 6px;
    font-size: 14px;
  }
  button.edit-button {
    background: #333;
    border-color: #333;
  }
`;

// MENU UPDATE MODAL
export const StyledMenuUpdateModal = styled(Modal)`
  min-width: 900px;

  .ant-modal-header {
    background: #eee;

    .ant-modal-title {
      font-size: 20px;
    }
  }
  .ant-modal-body {
    max-width: 900px;
    margin: 0 auto;
    min-height: 75vh;
  }

  .ant-row.ant-form-item-row {
    align-items: center;
  }

  .ant-form-item {
    margin-bottom: 16px;
  }

  input,
  .ant-form-item-control-input-content {
    max-height: 45px;
  }

  .ant-select-selector {
    max-height: 45px;
  }

  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item {
    line-height: 45px;
  }

  .ant-form-item-explain-error {
    display: none;
  }

  .section-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 25px;
  }

  .price-setting-section {
    padding-top: 25px;
  }

  .menu-update-thumbnail-form-item {
    height: 250px;
  }

  .image-button-flex-group {
    display: flex;
    gap: 16px;
  }

  .price-setting-description {
    font-size: 12px;
    color: #acacac;
    margin-top: 8px;
    margin-left: 110px;
  }
`;

export const MenuUpdateFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MenuUpdateFoodMallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MenuUpdateThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ebebeb;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: auto;

  width: 250px;
  height: 250px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
  }

  .non-image-description {
    text-align: center;

    .image-guide-description {
      font-size: 12px;
      color: #acacac;
    }
  }
`;

export const MenuUpdateButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 255px;

  .image-guide-description {
    font-size: 12px;
    color: #acacac;
  }
`;
